import Swiper, { Navigation } from 'swiper/core';

(function () {
  Swiper.use([Navigation]);
  const styles = getComputedStyle(document.documentElement);
  const spaceBetween = parseInt(styles.getPropertyValue('--spaceSmall'), 10);

  const sliders: NodeListOf<HTMLElement> = document.querySelectorAll('.product-card-slider');

  sliders.forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween,
      watchOverflow: true,

      // Navigation arrow  s
      navigation: {
        nextEl: '.product-card-slider__next',
        prevEl: '.product-card-slider__prev',
      },

      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  });
})();
